/* eslint-disable @atlassian/relay/graphql-naming */
import React from 'react';
import { styled } from '@compiled/react';
import { graphql, useFragment } from 'react-relay';
import Button from '@atlaskit/button';
import LinkIcon from '@atlaskit/icon/core/link';
import Tooltip from '@atlaskit/tooltip';
import type { UrlCellUrlCell$key } from '@atlassian/jira-relay/src/__generated__/UrlCellUrlCell.graphql';

type Props = {
	project: UrlCellUrlCell$key;
};

export const UrlCell = ({ project }: Props): React.JSX.Element | null => {
	const data = useFragment(
		graphql`
			fragment UrlCellUrlCell on JiraProject {
				projectUrl
			}
		`,
		project,
	);

	if (!data?.projectUrl) {
		return null;
	}

	const { projectUrl } = data;

	return (
		<UrlCellContent>
			<Tooltip content={projectUrl}>
				<Button
					appearance="subtle-link"
					href={projectUrl}
					target="_blank"
					spacing="none"
					iconBefore={<LinkIcon spacing="spacious" label={projectUrl} />}
				/>
			</Tooltip>
		</UrlCellContent>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const UrlCellContent = styled.div({
	display: 'flex',
	justifyContent: 'center',
});
